function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Alert, Spin, Button, Select, Space, Divider } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var EditUser = function EditUser(_ref) {
  var user = _ref.user,
    handleUpdate = _ref.handleUpdate;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormPrecessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isDataLoading = _useState8[0],
    setIsDataLoading = _useState8[1];
  var _useState9 = useState([{
      value: 0,
      label: "Aucune"
    }]),
    _useState0 = _slicedToArray(_useState9, 2),
    companyList = _useState0[0],
    setCompanyList = _useState0[1];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage('');
    setSuccessMessage('');
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append("company_id", values.company_id);
    formData.append('role', values.role);
    formData.append('password', values.password);
    formData.append('id', user.id);
    axios.post(Common.baseApiUrl + 'edituser/' + Common.currentUser.id, formData).then(function (response) {
      setIsFormProcessing(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handleUpdate();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue ' + error.toString());
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      role: 1,
      company_id: companyList[0].value
    });
  }, []);
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompanyList([]);
        response.data.companyList.forEach(function (c) {
          setCompanyList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
    form.setFieldsValue({
      role: user.role,
      company_id: user.company_id,
      firstname: user.firstname,
      lastname: user.lastname,
      mobile: user.mobile
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: errorMessage,
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: successMessage,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "role",
            label: "Role",
            children: /*#__PURE__*/_jsxs(Select, {
              defaultValue: 1,
              children: [/*#__PURE__*/_jsx(Option, {
                value: 1,
                children: "Accueil"
              }), /*#__PURE__*/_jsx(Option, {
                value: 2,
                children: "Loboratoire (saisie)"
              }), /*#__PURE__*/_jsx(Option, {
                value: 21,
                children: "Loboratoire (validation)"
              }), /*#__PURE__*/_jsx(Option, {
                value: 3,
                children: "Medecin"
              }), /*#__PURE__*/_jsx(Option, {
                value: 31,
                children: "Medecin (Validant)"
              }), /*#__PURE__*/_jsx(Option, {
                value: 4,
                children: "VISIO"
              }), /*#__PURE__*/_jsx(Option, {
                value: 5,
                children: "Audio"
              }), /*#__PURE__*/_jsx(Option, {
                value: 6,
                children: "Exploration"
              }), /*#__PURE__*/_jsx(Option, {
                value: 8,
                children: "Radiographie"
              }), /*#__PURE__*/_jsx(Option, {
                value: 7,
                children: "Partenaire"
              }), /*#__PURE__*/_jsx(Option, {
                value: 10,
                children: "S\xE9cr\xE9taire M\xE9dical"
              }), /*#__PURE__*/_jsx(Option, {
                value: 102,
                children: "Comptabilite"
              }), /*#__PURE__*/_jsx(Option, {
                value: 101,
                children: "Administrateur"
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Soci\xE9t\xE9",
            name: "company_id",
            rules: [{
              required: true,
              message: "Champ obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Select, {
              options: companyList
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "firstname",
            label: "Pr\xE9nom",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "lastname",
            label: "Nom",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {})
          })
        })]
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "T\xE9l\xE9phone (Login)",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              disabled: true
            })
          })
        })
      }), /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            disabled: isDataLoading,
            loading: isFormPrecessing,
            htmlType: "submit",
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "SAUVEGARDER"
            })
          })
        })
      })]
    })]
  });
};
export default EditUser;